import { Vertical } from '@/types/verticals'
import { MODES } from '@/fish/lib/enums'
import { FISH_ACTIVITY_MODES } from '@/fish/lib/layers/activity-modes'

const verticalActivityModes = {
  [Vertical.Fish]: FISH_ACTIVITY_MODES,
}

export const getLabelForMode = (mode) => {
  return {
    [MODES.FRESHWATER]: '',
  }[mode]
}

export const getModeToggleableLayers = (mode, app) => {
  const activityModes = verticalActivityModes[app]
  return activityModes[mode].layers.filter((layer) => layer.label)
}

export const getConditionsToggleableLayers = (mode, app) => {
  if (app !== Vertical.Backcountry) {
    return []
  }
  const activityModes = verticalActivityModes[app]
  return activityModes[mode]?.conditionsLayers || []
}

export const getCellCoverageToggleableLayers = (mode, app) => {
  if (app !== Vertical.Backcountry) {
    return []
  }
  const activityModes = verticalActivityModes[app]
  return activityModes[mode]?.cellCoverageLayers || []
}

export const getNonModeToggleableLayers = (mode, app) => {
  const activityModes = verticalActivityModes[app]
  return activityModes[mode].allLayers
}
